import styled from 'styled-components';

import { getScreenSize, getThemeColor, getThemeSize } from '../../../utils/theme';

import bgTop from '../../assets/imgs/legal_pages_gb.png';

export const PageWrapS = styled.div`
  margin-top: -70px;
  background-image: url(${bgTop});
  background-repeat: no-repeat;
`;

export const PageContentS = styled.div`
  width: 996px;
  margin: 0 auto;
  padding-top: 140px;
  
  @media (max-width: ${getScreenSize(['tabletPC'])}) {
    width: 90%;
  }
`;

export const PageHeaderS = styled.h1`
  color: ${getThemeColor(['darkerViolet'])};
  font-size:${getThemeSize(['headers', 'main'])};
  font-weight: normal;
  text-align: center;
  text-transform: uppercase;
  margin: 0 auto 70px;
`;

export const SectionHeaderS = styled.h2`
   text-transform: uppercase;
   font-size:${getThemeSize(['headers', 'secondary'])};
   color: ${getThemeColor(['darkerViolet'])};
   font-weight: normal;
   margin-bottom: 30px;
`;

export const Paragraph = styled.p`
   color: ${getThemeColor(['primary'])};
   font-size: ${getThemeSize(['bigText'])};
   white-space: pre-line;
   line-height: 24px;
   margin-bottom: 70px;
`;
